import { render, staticRenderFns } from "./NewVersionMarker.vue?vue&type=template&id=da71c20a&scoped=true&"
import script from "./NewVersionMarker.vue?vue&type=script&lang=js&"
export * from "./NewVersionMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da71c20a",
  null
  
)

export default component.exports